import { IGetNomeAuditorDropDownUseCase } from "../../../presentation/useCases/read/get_nome_auditor_drop_down_use_case";
import { NomeAuditorDropDown } from "../../models/nome_auditor_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

//GetNomeAuditorDropDownUseCase

export class GetNomeAuditorDropDownUseCase implements IGetNomeAuditorDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getNomeAuditorDropDown(): Promise<NomeAuditorDropDown[]> {
    return await this.repository.getNomeAuditorDropDown();
  }
}
